import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { ENV } from '../../ENV'
import { useUser } from '../../hooks/useUser'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Loading from '../Loading/Loading'
import InfoLine from './InfoLine'
import ProtectOrgUser from './ProtectOrgUser'

interface iLayout {
  isAdmin?: boolean
}

const Layout = ({ isAdmin }: iLayout) => {
  const { userLoading, userIsLoged, logout } = useUser()

  useEffect(() => {
    if (ENV.MAINTENANCE_MODE_LOGOUT && userIsLoged && !isAdmin) {
      logout()
    }
  }, [userIsLoged])

  return (
    <>
      <Header isAdmin={isAdmin} />
      {ENV.MAINTENANCE_MODE_LOGOUT && <InfoLine />}
      <main role='main' id='content'>
        {userLoading ? (
          <Loading />
        ) : (
          <ProtectOrgUser>
            <Outlet />
          </ProtectOrgUser>
        )}
      </main>
      <Footer />
    </>
  )
}

export default Layout
